import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ROUTES } from '../../utils/Routes';
import styles from '../../styles/Header.module.css';

const Header: React.FC = () => {
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const isHomePage = location.pathname === '/';

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Navbar
            expand="lg"
            fixed="top"
            className={`${isHomePage && !isScrolled ? styles.transparentNav : styles.whiteNav} shadow-sm`}
        >
            <Container>
                <Navbar.Brand href="/">
                    <img
                        src="/images/logo.svg"
                        alt="Symbioun Logo"
                        className="d-inline-block align-top logo-img"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto">
                        <Nav.Link href={ROUTES.HOMEPAGE_ROUTE}>Home</Nav.Link>
                        <Nav.Link href={ROUTES.ABOUTUS_ROUTE}>About</Nav.Link>
                        <NavDropdown title="Our Services" id="services-dropdown">
                            <NavDropdown.Item href={ROUTES.SERVICE_ROUTE+'/business-consultation'}>Business Consultation</NavDropdown.Item>
                            <NavDropdown.Item href={ROUTES.SERVICE_ROUTE+'/start-up-funding'}>Start-up Funding</NavDropdown.Item>
                            <NavDropdown.Item href={ROUTES.SERVICE_ROUTE+'/community-empowerment'}>Community Empowerment</NavDropdown.Item>
                            <NavDropdown.Item href={ROUTES.SERVICE_ROUTE+'/esg-csr-project'}>ESG/CSR Project Management and Consulting</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link href={ROUTES.CONTACTUS_ROUTE}>Contact</Nav.Link>
                    </Nav>
                    <Button href={ROUTES.CONTACTUS_ROUTE} className={styles.gradientButton}>
                        Consultancy
                    </Button>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header; 